import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import NotAuthorised from '@/components/errors/NotAuthorised';
import { fetchSearches, toggleSearchesPresentation, toggleSearchSelected } from '../actions';

const SearchesPanelContainer = ({
  readErrors,
  canRead,
  className,
  children,
}) => {
  if (!canRead || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-searches-panel-container', className)}>
      { children }
    </div>
  );
};

export const mapStateToProps = ({
  auth: { role: { permissions: { search: { read } } } },
  search: { searches },
}, { category, displayAs }) => {
  const item = searches[category];
  return {
    canRead: read,
    currentPage: item.currentPage,
    display: displayAs || item.display,
    pageCount: item.totalPages,
    pageSize: item.pageSize,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    searches: item.results,
    total: item.count,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchSearches,
  onCheckBoxClick: toggleSearchSelected,
  togglePresentation: toggleSearchesPresentation,
};

export default SearchesPanelContainer;
